import React, { useEffect, useState } from 'react';
import { Form as DumbForm } from '@tribeplatform/react-components/Form';
import { useI18n } from '@tribeplatform/react-components/i18n';
import { useTribeClient } from '@tribeplatform/react-sdk';
import { ExtraInteractionsEvents } from '@tribeplatform/react-sdk/types';
import { useSlate } from '../../hooks/index.js';
export const FormBlock = ({ callbackId, defaultValues: uncleanDefaultValues, children, }) => {
    const { $t } = useI18n();
    const { config } = useTribeClient();
    const { interactionsContext: { interactionEmitter }, } = config !== null && config !== void 0 ? config : {};
    const [loading, setLoading] = useState(false);
    const { extraContext: { slate: { callback }, }, } = useSlate();
    let defaultValues = {};
    try {
        defaultValues =
            typeof uncleanDefaultValues === 'string'
                ? JSON.parse(uncleanDefaultValues)
                : uncleanDefaultValues;
    }
    catch (_a) { }
    useEffect(() => {
        const errorInteractionListenerHandler = () => {
            setLoading(false);
        };
        const appInteractionCalledListenerHandler = () => {
            setLoading(true);
        };
        if (interactionEmitter) {
            interactionEmitter.on(ExtraInteractionsEvents.InteractionError, errorInteractionListenerHandler);
            interactionEmitter.on(ExtraInteractionsEvents.InteractionCalled, appInteractionCalledListenerHandler);
        }
        return () => {
            if (interactionEmitter) {
                interactionEmitter.removeListener(ExtraInteractionsEvents.InteractionError, errorInteractionListenerHandler);
                interactionEmitter.removeListener(ExtraInteractionsEvents.InteractionCalled, appInteractionCalledListenerHandler);
            }
        };
    }, [interactionEmitter, setLoading, $t]);
    return (React.createElement(DumbForm, { loading: loading, onSubmit: data => callback(callbackId, { data }), defaultValues: defaultValues }, children));
};
//# sourceMappingURL=Block.js.map